module.exports = {
	"product": "สินค้า",
	"productEdit": "สินค้าทั้งหมด",
	"brand": "แบรนด์",
	"refCode": "รหัสสินค้า",
	"name": "ชื่อสินค้า",
	"type": "ประเภท",
	"discount": "ส่วนลด",
	"totalPrice": "ราคารวม",
	"quantity": "จำนวน",
	"retailPrice": "ราคาค่าเช่า",
	"price": "ราคา",
	"create": "เพิ่มสินค้า",
	"deleteConfirmText": "ทำการลบสินค้า",
	"addBrand": "เพิ่มยี่ห้อ",
	"remark": "ข้อความเพิ่มเติม",
	"status": "สถานะ",
	"depositPrice": "เงินมัดจำ",
	"size": "ขนาด",
	"color": "สี",
	"extendRentPrice": "ราคาเช่าต่อ",
	"lateFee": "ค่าปรับคืนช้า",
	"depositUpcountry": "ค่ามัดจำต่างจังหวัด",
	"images": "รูปภาพเพิ่มเติม",
	"category": "ชนิดสินค้า",
	"extraDescription": "รายละเอียดเพิ่มเติม",
	"discountable": "ลดราคาได้",
	"discountableShort": "ลดได้"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/product.json
// module id = 839
// module chunks = 1